import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const NewNotificationsApi = createApi({
  reducerPath: "NewNotifications",
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_BACKEND_URL}`,
    prepareHeaders: (headers) => {
      const token = localStorage.getItem("token");
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      return headers;
    },
  }),
  endpoints: (builder) => ({
    // GET /fsmNotifications - Get user notifications
    getNewNotfications: builder.query({
      query: ({ page, limit = 10 }) => `fsmNotifications?page=${page}&limit=${limit}`,
    }),

    // GET /fsmNotifications with filters
    getAllNotfications: builder.query({
      query: (val) => {
        const page = val.page ?? 1;
        const limit = val.limit ?? 5;
        const sortBy = val.sortby ? `&sortBy=${val.sortby}` : "";
        const sortOrder = val.sortorder ? `&sortOrder=${val.sortorder}` : "";
        const search = val.search ? `&search=${val.search}` : "";
        const from = val.from ? `&from=${val.from}` : "";
        const to = val.to ? `&to=${val.to}` : "";
        const id = val.selectedid ? `&id=${val.selectedid}` : "";
        return `fsmNotifications?page=${page}&limit=${limit}${search}${sortBy}${sortOrder}${from}${to}${id}`;
      },
    }),

    // GET /fsmNotifications?status=unread - Get unread notifications
    getUnreadNotfications: builder.query({
      query: ({ page, limit = 10 }) => `fsmNotifications?page=${page}&limit=${limit}&status=unread`,
    }),

    // GET /fsmNotifications/unread-count - Get unread count
    getNotificationsCount: builder.query({
      query: () => `fsmNotifications/unread-count`,
    }),

    // PATCH /fsmNotifications/:notificationId/read - Mark single notification as read
    markNotification: builder.mutation({
      query: ({ notificationId, source }) => ({
        url: `fsmNotifications/${notificationId}/read`,
        method: "PATCH",
        headers: { "Content-Type": "application/json" },
        body: { source },
      }),
    }),

    // PATCH /fsmNotifications/mark-all-read - Mark all notifications as read
    markAllNotifications: builder.mutation({
      query: () => ({
        url: `fsmNotifications/mark-all-read`,
        method: "PATCH",
        headers: { "Content-Type": "application/json" },
      }),
    }),

    // DELETE /fsmNotifications/:notificationId - Delete notification
    deleteNotification: builder.mutation({
      query: (notificationId) => ({
        url: `fsmNotifications/${notificationId}`,
        method: "DELETE",
      }),
    }),

    // POST /fsmNotifications/register-device - Register device for push
    registerDevice: builder.mutation({
      query: (deviceData) => ({
        url: `fsmNotifications/register-device`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: deviceData,
      }),
    }),

    // POST /fsmNotifications/deregister-device - Deregister device
    deregisterDevice: builder.mutation({
      query: (deviceData) => ({
        url: `fsmNotifications/deregister-device`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: deviceData,
      }),
    }),
  }),
});

export const {
  useGetNewNotficationsQuery,
  useGetNotificationsCountQuery,
  useGetUnreadNotficationsQuery,
  useMarkNotificationMutation,
  useMarkAllNotificationsMutation,
  useGetAllNotficationsQuery,
  useDeleteNotificationMutation,
  useRegisterDeviceMutation,
  useDeregisterDeviceMutation,
} = NewNotificationsApi;